import React, { Component } from 'react';
import {
  Grid,
  Icon,
  Button,
  Divider,
  Dropdown,
  Label,
  Form
} from 'semantic-ui-react';
import '../customerinfo/custinfo.css';
class Matinfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listitems: [],
      list: [],
      editing: false,
      editvalue: {},
      deletevalue: [],
      deletelist: [],
      editinfo: {},
      newcontact: false
    };
  }
  // componentDidUpdate(prevProps, prevState) {
  //   if (this.props.materials.length && !this.state.list.length) {
  //     this.genVendors();
  //   }
  //   console.log(this.props.materials);
  // }
  // componentDidMount() {
  //   if (this.props.materials.length && !this.state.list.length) {
  //     this.genVendors();
  //   }
  // }

  handlesave() {
    if (this.state.newcontact) {
      this.props.addmaterial(this.state.editvalue);
      this.setState({ newcontact: false });
    } else {
      this.props.updatemat(this.state.editvalue);
    }
  }
  handledelete() {
    console.log(this.state.deletevalue);

    this.state.deletevalue.map(dl => this.props.handleDelete(dl.matnumber));

    this.setState({ deletevalue: [] });
  }
  geneditform() {
    let material = Object.assign({}, this.state.editvalue);
    var formtitle = 'Edit:';
    if (this.state.newmaterial === true) {
      formtitle = 'Add Contact';
    }
    if (this.state.editing !== false) {
      return (
        <div>
          <Grid>
            <Grid.Column width={2}>
              <h3>{formtitle}</h3>
            </Grid.Column>
            <Grid.Column width={8}>
              <h4>{material.matnumber + ' ' + material.companyname}</h4>
            </Grid.Column>

            <Grid.Column width={3}>
              <Button
                id="billingsavebtn"
                color="green"
                onClick={() => this.handlesave()}
              >
                Save
              </Button>
              <Button
                id="billingsavebtn"
                onClick={() => this.setState({ editing: false })}
              >
                Cancel
              </Button>
            </Grid.Column>
          </Grid>
          <Divider />
          <Form>
            <Grid>
              <Grid.Column width={2} textAlign="center">
                <Label size="large">
                  Material Number: {'  ' + material.matnumber}
                </Label>
              </Grid.Column>
              <Grid.Column width={10}>
                <Form.Group>
                  <Form.Input
                    width={16}
                    label="Company Name"
                    value={material.companyname}
                    onChange={e => {
                      material.companyname = e.target.value;
                      this.setState({ editvalue: material });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={16}
                    label="Street Address"
                    value={material.streetaddress}
                    onChange={e => {
                      material.streetaddress = e.target.value;
                      this.setState({ editvalue: material });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={6}
                    label="City"
                    value={material.city}
                    onChange={e => {
                      material.city = e.target.value;
                      this.setState({ editvalue: material });
                    }}
                  />
                  <Form.Input
                    width={3}
                    label="State"
                    value={material.state}
                    onChange={e => {
                      material.state = e.target.value;
                      this.setState({ editvalue: material });
                    }}
                  />
                  <Form.Input
                    width={3}
                    label="Zip Code"
                    value={material.zipcode}
                    onChange={e => {
                      material.zipcode = e.target.value;
                      this.setState({ editvalue: material });
                    }}
                  />
                </Form.Group>
                <Divider />
                <Form.Group>
                  <Form.Input
                    width={8}
                    label="1st Purchasing Contact"
                    value={material.purchdeptcontact1}
                    onChange={e => {
                      material.purchdeptcontact1 = e.target.value;
                      this.setState({ editvalue: material });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={4}
                    label="Phone #"
                    value={material.workphone1}
                    onChange={e => {
                      material.workphone1 = e.target.value;
                      this.setState({ editvalue: material });
                    }}
                  />
                  <Form.Input
                    width={4}
                    label="Email 1"
                    value={material.email1}
                    onChange={e => {
                      material.email1 = e.target.value;
                      this.setState({ editvalue: material });
                    }}
                  />
                  <Form.Input
                    width={4}
                    label="Email 2"
                    value={material.email2}
                    onChange={e => {
                      material.email1 = e.target.value;
                      this.setState({ editvalue: material });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.TextArea
                    width={8}
                    label="Notes"
                    value={material.notes}
                    onChange={e => {
                      material.notes = e.target.value;
                      this.setState({ editvalue: material });
                    }}
                  />
                </Form.Group>
              </Grid.Column>
            </Grid>
          </Form>
        </div>
      );
    }
  }

  render() {
    const max = this.props.materials.reduce(
      (prev, current) => (prev.matnumber > current.matnumber ? prev : current),
      0
    );
    var newmaterial = {
      matnumber: max.matnumber + 1,
      companyname: '',
      streetaddress: '',
      city: '',
      state: '',
      zipcode: '',
      workphone1: '',
      workfax: '',
      workphone2: '',
      cellphonenumber: '',
      beepernumber: '',
      contact: '',
      email1: '',
      email2: '',
      notes: '',
      createdAt: '2018-01-08T18:36:35.000Z',
      updatedAt: '2018-01-08T18:36:35.000Z'
    };
    var matdrop = this.props.materials.map(item => {
      let itemtext = item.matnumber + ' - ' + item.companyname;
      return {
        key: item.matnumber,
        value: item,
        text: itemtext
      };
    });
    return (
      <div className="Matinfo">
        <Grid>
          <Grid.Column width={5}>
            <Label>Select Vendor to Edit</Label>
            <Dropdown
              placeholder="Vendor"
              fluid
              search
              selection
              options={matdrop}
              onChange={(e, { value }) => {
                this.setState({
                  editvalue: value,
                  newcontact: false,
                  editing: true
                });
              }}
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <Button
              color="blue"
              id="deletecontactbutton"
              onClick={() =>
                this.setState({
                  newcontact: true,
                  editing: true,
                  editvalue: newmaterial
                })
              }
            >
              <Icon name="plus" /> Contact
            </Button>
          </Grid.Column>
          <Grid.Column width={6}>
            <Label>Select Vendors to Delete</Label>
            <Dropdown
              placeholder="Select Billing Contact to Delete"
              fluid
              search
              selection
              value={this.state.deletevalue}
              multiple
              options={matdrop}
              onChange={(e, { value }) => {
                this.setState({ deletevalue: value });
              }}
            />
          </Grid.Column>
          <Grid.Column width={1}>
            <Button
              negative
              id="deletecontactbutton"
              onClick={() => this.handledelete()}
            >
              Delete
            </Button>
          </Grid.Column>
        </Grid>
        <Divider />

        {this.geneditform()}
      </div>
    );
  }
}
export default Matinfo;



// WEBPACK FOOTER //
// ./src/components/hr/materials.jsx